import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import { Divider, Tooltip, Typography } from '@mui/material';
import UserAvatarBio from 'Components/SharedComponents/UserAvatar/UserAvatarBio';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { ISideNav } from 'shared/SharedModels';
import { LeftNavButtonStyled } from 'shared/SharedStyles/ShInputs';
import { LeftPanelContainer, MobileOnlyStack, ShIconWrapper, SideNavLinksStack } from 'shared/SharedStyles/ShLayouts';
import { togglePricingDialog } from 'store/slices/app/app-info-slice';
import { logoutAccount } from 'store/slices/auth-v2/auth-v2-slice';
import { AppLayoutNavLinks } from './AppLayoutConstants';

export const SideNav = ({ isMiniDrawer, toggleDrawer }: ISideNav) => {
    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(logoutAccount({ logoutType: 'user' }));
    };

    const LabelWithDynamicTooltip = (Icon: React.SVGProps<SVGSVGElement>, label: string) => {
        return (<>
            {isMiniDrawer ?
                <Tooltip placement='right-end' title={label} arrow>
                    <ShIconWrapper>{Icon}</ShIconWrapper>
                </Tooltip> :
                <ShIconWrapper>{Icon}</ShIconWrapper>}
            {!isMiniDrawer && <Typography variant='body2'>{label}</Typography>}
        </>)
    };

    return (
        <LeftPanelContainer>
            <UserAvatarBio isMiniDrawer={isMiniDrawer} />
            <Divider />
            <SideNavLinksStack>
                {AppLayoutNavLinks.map((link, index) => (
                    <NavLink to={link.redirectTo} aria-label={link.label} key={index}
                        className={({ isActive }) => isActive ? "active" : ""} onClick={toggleDrawer}>
                        {LabelWithDynamicTooltip(link.icon, link.label)}
                    </NavLink>
                ))}
            </SideNavLinksStack>
            <MobileOnlyStack>
                <Divider />
                <LeftNavButtonStyled startIcon={<MonetizationOnOutlinedIcon />} onClick={() => dispatch(togglePricingDialog())}>Pricing</LeftNavButtonStyled>
                <LeftNavButtonStyled startIcon={<HelpOutlineOutlinedIcon />} href='/employer/help'>Help</LeftNavButtonStyled>
                <LeftNavButtonStyled startIcon={<LogoutIcon className='logout-icon' />} onClick={handleLogout}>Log out</LeftNavButtonStyled>
            </MobileOnlyStack>
        </LeftPanelContainer>
    );
};
